module.exports = __webpack_public_path__ + "static/media/pic6.31734bd0.jpg";